export default "__VITE_ASSET__BXUjCwg7__"